// extracted by mini-css-extract-plugin
module.exports = {"box":"SearchBar_box__11xCY","forma":"SearchBar_forma__3Vgs1"};